(() => {
  if (window.nvCartInstalled) return;
  window.nvCartInstalled = true;
  let busy = false;
  let lastOpener = null;
  let noteTimer;
  const drawer = () => document.getElementById('NvCartDrawer');
  const root = () => drawer()?.dataset.nvRoot || window.Shopify?.routes?.root || '/';
  const message = (name) => drawer()?.dataset[name] || '';
  const cartPage = () => document.querySelector('[data-nv-cart-section]');
  const sectionIds = () => [drawer()?.dataset.nvDrawerSection, cartPage()?.dataset.nvCartSection].filter(Boolean);
  const errorRegion = (scope) => scope?.querySelector('[data-nv-cart-error]') || drawer()?.querySelector('[data-nv-cart-error]') || cartPage()?.querySelector('[data-nv-cart-error]');
  const showError = (scope, error) => {
    const region = errorRegion(scope);
    if (region) region.textContent = typeof error === 'string' ? error : message('nvError');
  };
  const open = (opener) => {
    const panel = drawer();
    if (!panel) { window.location.assign(root() + 'cart'); return; }
    if (opener) lastOpener = opener;
    if (!panel.open) panel.showModal();
  };
  const close = () => {
    drawer()?.close();
    if (lastOpener?.isConnected) lastOpener.focus({ preventScroll: true });
  };
  const lock = (value) => {
    busy = value;
    document.querySelectorAll('[data-nv-cart-item]').forEach((item) => item.setAttribute('aria-busy', String(value)));
    document.querySelectorAll('[data-nv-cart-step], [data-nv-cart-quantity], .nv-cart__button[name="checkout"], .nv-drawer__button[name="checkout"]').forEach((control) => { control.disabled = value; });
  };
  const render = (sections, keepOpen = false) => {
    const wasOpen = drawer()?.open || keepOpen;
    const focus = document.activeElement;
    const focusedItem = focus?.closest('[data-nv-cart-item]');
    const focusKey = focusedItem?.dataset.key;
    const focusType = focus?.matches('[data-nv-cart-quantity]') ? 'quantity' : focus?.dataset.nvCartStep;
    const note = cartPage()?.querySelector('[data-nv-cart-note]');
    const noteValue = note?.value;
    let rendered = false;
    for (const html of Object.values(sections || {})) {
      if (!html) continue;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      for (const selector of ['#NvCartDrawer', '[data-nv-cart-section]']) {
        const replacement = parsed.querySelector(selector);
        const current = document.querySelector(selector);
        if (replacement && current) {
          if (selector === '#NvCartDrawer') {
            current.replaceChildren(...replacement.childNodes);
            for (const [key, value] of Object.entries(replacement.dataset)) current.dataset[key] = value;
          } else current.replaceWith(replacement);
          rendered = true;
        }
      }
    }
    if (!rendered) throw new Error(message('nvError'));
    if (noteValue !== undefined) {
      const replacementNote = cartPage()?.querySelector('[data-nv-cart-note]');
      if (replacementNote) replacementNote.value = noteValue;
    }
    const count = drawer()?.dataset.nvCartCountValue || cartPage()?.dataset.nvCartCountValue || '0';
    document.querySelectorAll('[data-nv-cart-count]').forEach((node) => { node.textContent = count; node.hidden = Number(count) === 0; });
    if (wasOpen) open();
    if (focusKey) {
      const scope = wasOpen ? drawer() : cartPage();
      const targetItem = [...(scope?.querySelectorAll('[data-nv-cart-item]') || [])].find((item) => item.dataset.key === focusKey);
      const selector = focusType === 'quantity' ? '[data-nv-cart-quantity]' : `[data-nv-cart-step="${focusType}"]`;
      targetItem?.querySelector(selector)?.focus({ preventScroll: true });
    }
    document.dispatchEvent(new CustomEvent('nv:cart-updated', { detail: { itemCount: Number(count) } }));
  };
  const request = async (endpoint, payload) => {
    const isForm = payload instanceof FormData;
    if (isForm) {
      payload.set('sections', sectionIds().join(','));
      payload.set('sections_url', root() + 'cart');
    } else {
      payload.sections = sectionIds();
      payload.sections_url = root() + 'cart';
    }
    const response = await fetch(root() + endpoint, {
      method: 'POST',
      headers: isForm ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: isForm ? payload : JSON.stringify(payload)
    });
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || message('nvError'));
    return data;
  };
  const refresh = async (keepOpen = false) => {
    const url = new URL(root() + 'cart', window.location.origin);
    url.searchParams.set('sections', sectionIds().join(','));
    const response = await fetch(url, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error(message('nvError'));
    render(await response.json(), keepOpen);
  };
  const update = async (item, quantity) => {
    if (busy || !item || !Number.isInteger(quantity) || quantity < 0) return;
    const scope = item.closest('dialog') || cartPage();
    const region = errorRegion(scope);
    if (region) region.textContent = '';
    lock(true);
    try {
      const data = await request('cart/change.js', { id: item.dataset.key, quantity });
      try { render(data.sections); } catch { await refresh(); }
    } catch (error) {
      showError(scope?.isConnected ? scope : document, error.message);
      try { await refresh(); } catch {}
      showError(drawer()?.open ? drawer() : cartPage(), error.message);
    } finally { lock(false); }
  };
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-nv-open-cart]');
    if (trigger) { event.preventDefault(); open(trigger); return; }
    if (event.target.closest('[data-nv-close-cart]')) { close(); return; }
    if (event.target === drawer()) {
      const rect = drawer().getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
      return;
    }
    const step = event.target.closest('[data-nv-cart-step]');
    const remove = event.target.closest('[data-nv-cart-remove]');
    if (remove) { event.preventDefault(); update(remove.closest('[data-nv-cart-item]'), 0); return; }
    if (step) {
      const item = step.closest('[data-nv-cart-item]');
      const input = item?.querySelector('[data-nv-cart-quantity]');
      if (!input) return;
      const increment = Number(input.step) || 1;
      update(item, Math.max(0, (Number(input.value) || 0) + Number(step.dataset.nvCartStep) * increment));
    }
  });
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-nv-cart-quantity]')) update(event.target.closest('[data-nv-cart-item]'), Math.max(0, Math.floor(Number(event.target.value) || 0)));
    if (event.target.matches('[data-nv-cart-note]')) {
      clearTimeout(noteTimer);
      const value = event.target.value;
      noteTimer = setTimeout(async () => {
        try {
          const response = await fetch(root() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: value }) });
          if (!response.ok) showError(cartPage(), message('nvError'));
        } catch { showError(cartPage(), message('nvError')); }
      }, 200);
    }
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.matches('[data-nv-add]')) {
      event.preventDefault();
      if (busy) return;
      let region = form.querySelector('[data-nv-add-error]');
      if (!region) { region = document.createElement('p'); region.setAttribute('role', 'status'); region.setAttribute('data-nv-add-error', ''); form.append(region); }
      region.textContent = '';
      const button = event.submitter || form.querySelector('button[type="submit"]');
      const payload = new FormData(form);
      lock(true);
      if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
      let added = false;
      try {
        const data = await request('cart/add.js', payload);
        added = true;
        lastOpener = button;
        try { render(data.sections, true); } catch { await refresh(true); }
      } catch (error) {
        if (added) window.location.assign(root() + 'cart');
        else region.textContent = error.message || message('nvError');
      } finally {
        lock(false);
        if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
      }
    }
    if (form.matches('[data-nv-discount-form]')) {
      event.preventDefault();
      if (busy) return;
      const code = new FormData(form).get('discount')?.trim();
      if (!code) return;
      lock(true);
      const button = form.querySelector('button[type="submit"]');
      if (button) button.disabled = true;
      try {
        const data = await request('cart/update.js', { discount: code });
        try { render(data.sections); } catch { await refresh(); }
        const container = cartPage();
        const details = container?.querySelector('.nv-cart__discount-box');
        if (details) details.open = true;
        const input = container?.querySelector('[name="discount"]');
        if (input) input.value = code;
        const status = container?.querySelector('[data-nv-discount-message]');
        const rejected = data.discount_codes?.some((entry) => entry.code?.toLowerCase() === code.toLowerCase() && entry.applicable === false);
        if (status) status.textContent = rejected ? message('nvDiscountInvalid') : message('nvDiscountApplied');
      } catch (error) { showError(cartPage(), error.message); }
      finally { lock(false); if (button?.isConnected) button.disabled = false; }
    }
  });
  document.addEventListener('cancel', (event) => {
    if (event.target === drawer() && lastOpener?.isConnected) requestAnimationFrame(() => lastOpener.focus({ preventScroll: true }));
  }, true);
  window.addEventListener('pageshow', (event) => { if (event.persisted) refresh().catch(() => {}); });
})();
